<!--
  Pointer-only affordance — see the class comment for why this is aria-hidden rather than
  given roles of its own. The avatar that summons it is a link to the same profile.
-->
<div class="user-hover-card" [class.user-hover-card--above]="placement === 'above'" aria-hidden="true" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  @if (loading) {
    <div class="user-hover-card__skeleton">
      <div class="user-hover-card__skeleton-cover"></div>
      <div class="user-hover-card__skeleton-avatar"></div>
      <div class="user-hover-card__skeleton-line user-hover-card__skeleton-line--name"></div>
      <div class="user-hover-card__skeleton-line"></div>
    </div>
  } @else if (unavailable) {
    <div class="user-hover-card__body">
      <p class="user-hover-card__muted m-b-0">Profile unavailable.</p>
    </div>
  } @else {
    <!-- Cover photo band. Falls back to the member's own avatar tint so the card never
         renders a blank grey strip for the many members who have no cover set. -->
    <div class="user-hover-card__cover" [style.background-color]="avatarColor">
      @if (coverPhoto) {
        <img [src]="coverPhoto" class="user-hover-card__cover-img" alt="" />
      }
    </div>

    <div class="user-hover-card__body">
      <div class="user-hover-card__avatar-wrap">
        @if (photo) {
          <img [src]="photo" class="user-hover-card__avatar" alt="" />
        } @else {
          <div class="user-hover-card__avatar user-hover-card__avatar--initials" [style.background-color]="avatarColor">{{ initials }}</div>
        }
      </div>

      <div class="user-hover-card__name">{{ name || "Community member" }}</div>

      @if (isPrivate) {
        <p class="user-hover-card__muted">This member's profile is private.</p>
      } @else if (tagline) {
        <p class="user-hover-card__tagline">{{ tagline }}</p>
      }

      <div class="user-hover-card__actions">
        <button type="button" class="btn btn-sm btn-secondary user-hover-card__action" (click)="viewProfile()">View profile</button>

        @if (!isMe && !isPrivate && user) {
          @switch (connectionState) {
            @case ("none") {
              <button type="button" class="btn btn-sm btn-primary user-hover-card__action" [disabled]="connecting" (click)="connect()">
                <fa-icon icon="plus"></fa-icon>
                {{ "com.connect" | translate }}
              </button>
            }
            @case ("sent") {
              <span class="user-hover-card__status">
                <fa-icon icon="check"></fa-icon>
                {{ "com.invite_sent" | translate }}
              </span>
            }
            @case ("connected") {
              <!-- Already connected, so "Connect" has nothing to offer — messaging is the
                   action that's actually available to you now. -->
              <button type="button" class="btn btn-sm btn-primary user-hover-card__action" (click)="sendMessage()">
                <fa-icon icon="comments"></fa-icon>
                {{ "com.send_message" | translate }}
              </button>
            }
            @case ("received") {
              <!-- They asked first. Reviewing happens on the profile page's connections
                   section, which is where accept/decline lives. -->
              <button type="button" class="btn btn-sm btn-primary user-hover-card__action" (click)="viewProfile()">{{ "general.review" | translate }}</button>
            }
          }
        }
      </div>
    </div>
  }
</div>
